import { z } from 'zod';

import { toneModeEnumValidator } from '../../validators';

export const TranslationVariantSchema = z.object({
  tone: toneModeEnumValidator,
  translation: z.string(),
});

export const TranslateSentenceResponseSchema = z.object({
  originalSentence: z.string(),
  translations: z.array(TranslationVariantSchema),
});

export type ITranslationVariantDto = z.infer<typeof TranslationVariantSchema>;
export type ITranslateSentenceResponseDto = z.infer<
  typeof TranslateSentenceResponseSchema
>;
